import { FontWeight } from 'common-assets/assets/fonts/fonts';
import { fontDisplay, lineHeightToFontSize } from 'common-react';
import { createStyles, makeStyles, Theme } from 'ui-components';

const WIDE_ILLUSTRATION_WIDTH = 190;
const WIDE_ILLUSTRATION_OFFSET_TOP = -66;
const WIDE_ILLUSTRATION_OFFSET_RIGHT = -10;
const WIDE_ILLUSTRATION_OFFSET_TOP_SM = -40;

const COMPACT_ILLUSTRATION_WIDTH = 91;
const COMPACT_ILLUSTRATION_OFFSET_TOP = -26;
const COMPACT_ILLUSTRATION_OFFSET_RIGHT = 26;

export default makeStyles((theme: Theme) => createStyles({
  promoCard: {
    boxShadow: `inset 0 0 0 1px ${theme.color.greys[15]}`,
    padding: 40,
    overflow: 'visible',

    [theme.breakpoints.down('sm')]: {
      padding: 24,
    },

    [theme.breakpoints.down('xs')]: {
      padding: 16,
    },
  },

  promoCardWide: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 24,
  },

  promoCardCompact: {
    position: 'relative',
  },

  promoText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    minWidth: 0,
  },

  promoTextCompact: {
    paddingRight: COMPACT_ILLUSTRATION_WIDTH + COMPACT_ILLUSTRATION_OFFSET_RIGHT,

    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },

  promoBadge: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '0 6px',
    borderRadius: 80,
    backgroundColor: theme.color.maroons[100],
    color: theme.color.constants.greys[0],
    font: fontDisplay('normal', theme.fontSize.xs, lineHeightToFontSize.xs),
  },

  promoDescription: {
    '& strong': {
      font: 'inherit',
      fontWeight: FontWeight.BOLD,
      color: theme.color.maroons[100],
    },
  },

  promoIllustration: {
    height: 'auto',

    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },

  promoIllustrationWide: {
    width: WIDE_ILLUSTRATION_WIDTH,
    flexShrink: 0,
    alignSelf: 'flex-start',
    marginTop: WIDE_ILLUSTRATION_OFFSET_TOP,
    marginRight: WIDE_ILLUSTRATION_OFFSET_RIGHT,

    [theme.breakpoints.down('sm')]: {
      marginTop: WIDE_ILLUSTRATION_OFFSET_TOP_SM,
      marginRight: 0,
    },
  },

  promoIllustrationCompact: {
    position: 'absolute',
    top: COMPACT_ILLUSTRATION_OFFSET_TOP,
    right: COMPACT_ILLUSTRATION_OFFSET_RIGHT,
    width: COMPACT_ILLUSTRATION_WIDTH,
  },
}), { name: 'RetirementCalculatorPromoCard' });
